import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { show } from 'redux-modal';
import get from 'lodash/get';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Confirm from 'react-confirm-bootstrap';
import moment from 'moment';
import { Tabs, Tab } from 'react-bootstrap';
import { Spinner } from '../../../components/common';
import { PublisherApi } from '../../../api';
import { humanize } from '../../../utils/helpers/text_formatters';
import WebsiteForm from '../../../components/publisher/websites/WebsiteForm';
import Report from '../../../components/publisher/reports/Report';
import { ButtonEdit, ButtonDelete } from '../../../components/common/buttons/actions';
import { ButtonAdd } from '../../../components/common/buttons';

class WebsiteIndex extends Component {
  state = { key: 1 };

  fetchWebsites(params = {}) {
    const { dispatch } = this.props;
    dispatch(PublisherApi.actions.websites(params));
  }

  newResource() {
    const { dispatch } = this.props;
    dispatch(show('WebsiteFormModal', {
      heading: 'New Website',
      formAction: 'Create',
    }));
  }

  handleEdit(c, r) {
    const { dispatch } = this.props;

    dispatch(show('WebsiteFormModal', {
      website: r,
      heading: `Editing Website - ${r.name}`,
      formAction: 'Update'
    }));
  }

  handleDelete(c) {
    const { dispatch } = this.props;
    dispatch(PublisherApi.actions.websiteDelete.post(c, (_error, success) => {
      if (success) { this.fetchWebsites(); }
    }));
  }

  handleTabSelect(key) {
    this.setState({ key });
  }

  handleOnPageChange(page, per_page) {
    this.fetchWebsites({
      page,
      per_page
    });
  }

  renderActions(c, r) {
    return (
      <ul className='list-inline'>
        <li>
          <ButtonEdit
            onClick={this.handleEdit.bind(this, c, r)}
          />
        </li>
        <li>
          <Confirm
            onConfirm={this.handleDelete.bind(this, c)}
            body='Are you sure you want to delete this?'
            confirmText='Confirm Delete'
            title={`Deleting Website - ${r.name}`}
          >
            <div><ButtonDelete /></div>
          </Confirm>
        </li>
      </ul>
    );
  }

  render() {
    const { websites, isLoading } = this.props;
    const { data, meta } = websites || {};
    const { pagination } = meta || {};
    const totalCount = get(pagination, 'total_count', null);
    const options = {
      sizePerPage: get(pagination, 'per_page', 10),
      onPageChange: this.handleOnPageChange.bind(this),
      sizePerPageList: [10, 20, 50, 100],
      pageStartIndex: 1,
      page: get(pagination, 'current_page', 1)
    };
    const fetchInfo = {
      dataTotalSize: totalCount || 0
    };

    return (
      <div>
        <div className='ibox'>
          <div className={`p-b-lg ibox-content${isLoading ? ' sk-loading' : ''}`}>
            <Spinner />
            <Tabs
              activeKey={this.state.key}
              onSelect={this.handleTabSelect.bind(this)}
              id="controlled-tab"
            >
              <Tab eventKey={1} title="Websites" className='p-md'>
                <div className='m-b-sm text-left'>
                  <ButtonAdd
                    btnLabel='Add Website'
                    onClick={this.newResource.bind(this)}
                  />
                </div>

                <BootstrapTable
                  striped
                  ref='WebsitesTable'
                  remote
                  data={data || []}
                  pagination
                  fetchInfo={fetchInfo}
                  options={options}
                >
                  <TableHeaderColumn
                    width="200"
                    dataField="name"
                    dataFormat={(c, r) => {
                      return (
                        <Link to={`/publisher/home/websites/${r.slug}/dashboard`}>
                          {c}
                        </Link>
                      );
                    }}
                  >
                    Name
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="200"
                    dataField="url"
                    dataFormat={(c) => c}
                  >
                    URL
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="75"
                    dataField="cpa"
                    dataFormat={(c) => c}
                  >
                    CPA ($)
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="75"
                    dataField="cpc"
                    dataFormat={(c) => c}
                  >
                    CPC ($)
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="75"
                    dataField="default_slots"
                    dataFormat={(c) => c}
                  >
                    Slots
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="100"
                    dataField="status"
                    dataFormat={(c) => humanize(c)}
                  >
                    Status
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="100"
                    dataField="pixel_status"
                    dataFormat={(c) => humanize(c)}
                  >
                    Pixel Status
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="100"
                    dataField="sandbox"
                    dataFormat={(c) => (c ? 'Sandbox' : 'Live')}
                  >
                    Mode
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="150"
                    dataField="created_at"
                    dataFormat={(c) => moment(c).local().format('MMMM Do[,] YYYY')}
                  >
                    Date
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    isKey
                    width="250"
                    dataField="uuid"
                    dataFormat={this.renderActions.bind(this)}
                  >
                    Actions
                  </TableHeaderColumn>

                </BootstrapTable>
              </Tab>
              <Tab eventKey={2} title="Reports" className='p-md'>
                <Report />
              </Tab>
            </Tabs>
          </div>
        </div>
        <WebsiteForm isModal />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { publisher } = state;
  return { websites: publisher.websites.data, isLoading: publisher.websites.loading };
};

export default connect(mapStateToProps)(WebsiteIndex);
